<div class="">
  <app-data-table [columns]="cols" [data]="userData" [title]="tableTitle"[isDeletable]="'/setup' | hasPermission: 'Delete'"  [showAddButton]="'/setup' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/setup' | hasPermission: 'Edit'" 
    (onAdd)="addPrivilege()" (editEventRow)="updatePrivilege($event)" [url]="'/access/privileges/'"  [totalRecords]="totalRecords"[isView]="'/setup' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)" 
    (deleteEventRow)="deletePrivilege($event)"></app-data-table>
</div>


<p-dialog header="Add Privilege" [(visible)]="showAddDialog" [modal]="true" [style]="{ width: '400px' }"
  [closable]="true" [maximizable]="true">
 <form [formGroup]="privilegeForm" (ngSubmit)="submitAddForm()">
  <div class="p-fluid mt-4">
    
    <!-- Name Field -->
    <div class="field mb-3">
      <label for="menuName">Name*</label>
      <input id="menuName" type="text" pInputText formControlName="name" placeholder="Enter menu name" maxlength="100" />
      <small *ngIf="privilegeForm.controls['name'].invalid && privilegeForm.controls['name'].touched" class="p-error">
        <ng-container *ngIf="privilegeForm.controls['name'].hasError('required')">
          Menu Name is required.
        </ng-container>
        <ng-container *ngIf="privilegeForm.controls['name'].hasError('pattern')">
          Invalid characters. Only alphanumeric and special characters (&) are allowed.
        </ng-container>
      </small>
    </div>

    <!-- Code Field -->
    <div class="field mb-4">
      <label for="menuIcon">Code*</label>
      <input id="menuIcon" type="text" pInputText formControlName="code" placeholder="Code" maxlength="15" />
      <small *ngIf="privilegeForm.controls['code'].invalid && privilegeForm.controls['code'].touched" class="p-error">
        <ng-container *ngIf="privilegeForm.controls['code'].hasError('required')">
          Code is required.
        </ng-container>
        <ng-container *ngIf="privilegeForm.controls['code'].hasError('pattern')">
          Invalid characters. Only alphanumeric and special characters (&) are allowed.
        </ng-container>
      </small>
    </div>

    <!-- Description Field -->
    <div class="field mb-3">
      <label for="menuUrl">Description*</label>
      <textarea id="menuUrl" pInputTextarea formControlName="description" placeholder="Description" rows="4" class="w-100"></textarea>
      <small *ngIf="privilegeForm.controls['description'].invalid && privilegeForm.controls['description'].touched" class="p-error">
        <ng-container *ngIf="privilegeForm.controls['description'].hasError('required')">
          Description is required.
        </ng-container>
        <ng-container *ngIf="privilegeForm.controls['description'].hasError('pattern')">
          Invalid characters. Only alphanumeric, spaces, commas, periods, parentheses, and hyphens are allowed.
        </ng-container>
      </small>
    </div>

    <!-- Submit Button -->
    <div class="d-flex justify-content-end gap-2 mt-4">
      <button pButton type="submit" label="Submit" class="fetch-data-btn" [disabled]="privilegeForm.invalid" style="width:auto;"></button>
    </div>

  </div>
</form>

</p-dialog>

<p-dialog [header]="viewMode ? 'View Privilege' : 'Edit Privilege'" [(visible)]="showEditDialog" [modal]="true" [style]="{ width: '400px' }"
  [closable]="true" [maximizable]="true">
 <form [formGroup]="privilegeForm" (ngSubmit)="submitEditForm()">
  <div class="p-fluid mt-4">
    
    <!-- Name Field -->
    <div class="field mb-3">
      <label for="menuName">Name*</label>
      <input id="menuName" type="text" pInputText formControlName="name" placeholder="Enter menu name" maxlength="100" />
      <small *ngIf="privilegeForm.controls['name'].invalid && privilegeForm.controls['name'].touched" class="p-error">
        <ng-container *ngIf="privilegeForm.controls['name'].hasError('required')">
          Menu Name is required.
        </ng-container>
        <ng-container *ngIf="privilegeForm.controls['name'].hasError('pattern')">
          Invalid characters. Only alphanumeric and special characters (&) are allowed.
        </ng-container>
      </small>
    </div>

    <!-- Code Field -->
    <div class="field mb-4">
      <label for="menuIcon">Code*</label>
      <input id="menuIcon" type="text" pInputText formControlName="code" placeholder="Code" maxlength="15" />
      <small *ngIf="privilegeForm.controls['code'].invalid && privilegeForm.controls['code'].touched" class="p-error">
        <ng-container *ngIf="privilegeForm.controls['code'].hasError('required')">
          Code is required.
        </ng-container>
        <ng-container *ngIf="privilegeForm.controls['code'].hasError('pattern')">
          Invalid characters. Only alphanumeric and special characters (&) are allowed.
        </ng-container>
      </small>
    </div>

    <!-- Description Field -->
    <div class="field mb-3">
      <label for="menuUrl">Description*</label>
      <textarea id="menuUrl" pInputTextarea formControlName="description" placeholder="Description" rows="4" class="w-100"></textarea>
      <small *ngIf="privilegeForm.controls['description'].invalid && privilegeForm.controls['description'].touched" class="p-error">
        <ng-container *ngIf="privilegeForm.controls['description'].hasError('required')">
          Description is required.
        </ng-container>
        <ng-container *ngIf="privilegeForm.controls['description'].hasError('pattern')">
          Invalid characters. Only alphanumeric, spaces, commas, periods, parentheses, and hyphens are allowed.
        </ng-container>
      </small>
    </div>

    <!-- Submit Button -->
    <div class="d-flex justify-content-end gap-2 mt-4">
      <button pButton type="submit" label="Submit" class="fetch-data-btn" *ngIf="!viewMode" [disabled]="privilegeForm.invalid" style="width:auto;"></button>
    </div>

  </div>
</form>

</p-dialog>

<p-dialog header="Delete Privilege" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog mt-3">
    <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete privilege ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="confirmDelete()" class="mt-2">
    </p-button>
  </div>
</p-dialog>